<template>
  <div class="wrapper">
    <h3 class="header-wrapper">
      {{ $t('sign_documents_digitally') }}
    </h3>
    <v-layout class="mb-5" justify-center wrap>
      <v-flex class="sign-method-div" xs12 sm6 @click="$emit('signDocs', 'smartcard')">
        <img src="../assets/icons/ic-usb-gradient-64-px.svg" alt="USB drive">
        <br>
        <span class="type-span">
          {{ $t('usb_drive') }}
        </span>
      </v-flex>
      <v-flex class="sign-method-div" xs12 sm6 @click="$emit('signDocs', 'mobile')">
        <img src="../assets/icons/ic-sim-card-gradient-64-px.svg" alt="SIM card">
        <br>
        <span class="type-span">
          {{ $t('mobile_signature') }}
        </span>
      </v-flex>
      <v-flex class="sign-method-div" xs12 sm6 @click="$emit('signDocs', 'smartcard')">
        <img src="../assets/icons/ic-credit-card-gradient-64-px.svg" alt="Credit card">
        <br>
        <span class="type-span">
          {{ $t('identity_card') }}
        </span>
      </v-flex>
      <v-flex class="sign-method-div" xs12 sm6 @click="$emit('signDocs', 'smartid')">
        <img src="../assets/icons/smartid.svg" alt="Smart ID">
        <br>
        <span class="type-span">
          {{ $t('smart_id') }}
        </span>
      </v-flex>
      <v-flex class="sign-method-div" xs12 sm6 @click="$emit('signDocs', 'smartcard')">
        <img src="../assets/icons/eresidency.svg" alt="eResidency">
        <br>
        <span class="type-span">
          {{ $t('e_residency_card') }}
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'DigitalDocumentSign',
};
</script>

<style>
  .type-span {
    font-size: 22px;
  }

  .sign-method-div {
    padding: 8px;
    margin: 0 auto 16px;
    max-width: 320px;
    display: inline-block;
    text-align: center;
  }

  .sign-method-div:hover {
    background: #f3f3f3;
    cursor: pointer;
  }
</style>
